import { type RouteObject } from '../index';

import AdminsRoutes from './Admins';
import OfficesRoutes from './Offices';
import UsersRoutes from './Users';

const AdminRoutes: RouteObject[] = [
    ...AdminsRoutes,
    ...OfficesRoutes,
    ...UsersRoutes,
]

export default AdminRoutes;